import styled from "styled-components";
import { colors } from "@streeteasy/design-system";
import { func, string } from "prop-types";

const XButton = styled.button.attrs(({ onClick: propsOnClick, ...props }) => ({
  type: "button",
  onClick: event => propsOnClick({ event }),
  "aria-label": props.ariaLabel
}))`
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  height: 16px;
  overflow: hidden;
  position: relative;
  width: 16px;
  z-index: 100;

  &:before {
    background-color: ${props => props.color};
    content: "";
    display: block;
    height: 140%;
    left: 50%;
    position: absolute;
    top: -20%;
    transform: translateX(-50%) rotate(45deg);
    width: 1px;
  }

  &:after {
    background-color: ${props => props.color};
    content: "";
    display: block;
    height: 140%;
    left: 50%;
    position: absolute;
    top: -20%;
    transform: translateX(-50%) rotate(-45deg);
    width: 1px;
  }
`;

XButton.propTypes = {
  /**
   * Optional override of default aria-label
   */
  ariaLabel: string,
  /**
   * Optional custom color for the close button, defaults to goatGrey from
   * the StreetEasy color palette.
   */
  color: string,
  /**
   * Callback for click event.
   *
   * @param {Object} params
   * @param {SyntheticEvent} params.event The react `SyntheticEvent`
   */
  onClick: func
};

XButton.defaultProps = {
  ariaLabel: "close",
  color: colors.GRAY,
  onClick: () => {}
};

export default XButton;
